<template>
    <div>
        main
    </div>
</template>

<script>
    export default {
        name: "ExampleMain"
    }
</script>

<style scoped>

</style>